import styled from 'styled-components';
import { whiteColor, screenSize, boldFont, primaryColor } from '@app/styles';

type Props = {
  disabled: boolean;
};
type ButtonProps = {
  showSecondaryBackground?: boolean;
  disabled?: boolean;
};
export const BackgroundContainer = styled.div`
  background: ${whiteColor};
  border-bottom: 1px solid #dce0e8;
  top: 55px;
  position: fixed;
  left: 0;
  width: 100%;
  z-index: 2;
  @media (${screenSize.tablet}) {
    top: 55px;
  }
`;
export const Container = styled.div`
  height: 50px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  position: relative;
  @media (${screenSize.tablet}) {
    height: 60px;
    padding: 0px 40px;
  }
`;
export const InfoBox = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  position: relative;
  padding: 0 0px 0 20px;
  @media (${screenSize.tablet}) {
    padding: 0px;
  }
`;
export const DetailsBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  position: relative;
  @media (${screenSize.tablet}) {
  }
`;

export const ButtonsBox = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding-right: 15px;
  @media (${screenSize.tablet}) {
    padding-top: 5px;
    padding-right: 0px;
  }
`;
export const DetailsItem = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  position: relative;
  @media (${screenSize.tablet}) {
    flex-direction: row;
  }
`;
export const Line = styled.div`
  display: none;
  @media (${screenSize.tablet}) {
    display: block;
    height: 25px;
    width: 1px;
    margin: 0px 5px;
    background-color: black;
    border: 1px solid black;
    opacity: 0.2;
    margin: 0px 15px;
  }
`;

export const Label = styled.div`
  display: none;
  @media (${screenSize.tablet}) {
    display: block;
    font-family: Noto Serif;
    font-style: normal;
    opacity: 0.8;
    font-size: 13px;
    color: #3d4654;
    line-height: 24px;
    font-weight: 500;
  }
`;

export const DesktopStatus = styled.div`
  display: none;
  @media (${screenSize.tablet}) {
    display: block;
    font-style: normal;
    margin: 0;
  }
`;

export const Value = styled.div`
  color: #3d4654;
  ${boldFont};
  font-size: 16px;
  margin-left: 10px;
  font-family: Noto Serif;
  font-style: normal;
  @media (${screenSize.tablet}) {
    margin-left: 0px;
    margin-right: 10px;
    line-height: 21px;
  }
`;

export const ButtonItem = styled.div`
  display: none;
  @media (${screenSize.desktop}) {
    // width: 150px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 10px;
    ${({ disabled }: Props) => {
      if (disabled) {
        return `
          button{
            background-color:#ccc;
            pointer-events:none;
          }
      `;
      }
    }}
  }
`;
export const SaveTransction = styled.div`
  display: none;
  @media (${screenSize.tablet}) {
    width: 150px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 10px;
    ${({ disabled }: Props) => {
      if (disabled) {
        return `
          button{
            background-color:#ccc;
            pointer-events:none;
          }
      `;
      }
    }}
  }
`;
export const MobileButtonItem = styled.div`
  display: none;
  @media (${screenSize.tablet}) {
    display: block;
    width: 160px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 5px;
    ${({ disabled }: Props) => {
      if (disabled) {
        return `
          button{
            background-color:#ccc;
            pointer-events:none;
          }
      `;
      }
    }}
  }
`;

export const CancelButton = styled.div`
  display: none;
  @media (${screenSize.desktop}) {
    display: block;
    color: #2e3b4f;
    font-weight: bold;
    font-size: 15px;
    line-height: 19px;
    margin-right: 16px;
    cursor: pointer;
  }
`;
export const CancelTransactionButton = styled.div`
  display: none;
  @media (${screenSize.tablet}) {
    display: block;
    color: #2e3b4f;
    font-weight: bold;
    font-size: 15px;
    line-height: 19px;
    margin-right: 16px;
    cursor: pointer;
  }
`;

export const OptionalButton = styled.div`
  display: none;
  @media (${screenSize.desktop}) {
    display: block;
    // margin-right: 10px;
  }
`;
export const ApprovedButton = styled.div`
  display: none;
  @media (${screenSize.desktop}) {
    display: block;
    margin-left: 10px;
  }
`;
export const MobileCancelButton = styled.div`
  display: block;
  cursor: pointer;
  font-size: 15px;
  margin-right: 30px;
  margin-top: 0;
  @media (${screenSize.tablet}) {
    display: none;
  }
`;
export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  @media (${screenSize.tablet}) {
  }
`;

export const StatusText = styled.div`
  display: none;
  @media (${screenSize.tablet}) {
    display: block;
    font-size: 15px;
    color: #d63763;
    margin-left: 16px;
    ${boldFont};
  }
`;
export const SavingIndicator = styled.div`
  margin-right: 50px;
  top: 15px;
  svg {
    path {
      fill: ${whiteColor};
    }
  }
  @media (${screenSize.tablet}) {
    left: 30px;
    margin-right: 50px;
    svg {
      path {
        fill: ${primaryColor};
      }
    }
  }
`;
